// rotateGizmoColors — the rotate gizmo's ring colours, matching PlayCanvas.
//
// FUNCTIONAL colours, allowlisted like axisColors.js: X/Y/Z ring identity is a
// convention shared by every DCC, and a palette switch retinting the rings would
// break the pairing between a ring and the axis numbers in the inspector.
//
// Values are PlayCanvas's own (engine/src/extras/gizmo/color.js):
//
//     COLOR_RED    = (1,   0.3, 0.3)
//     COLOR_GREEN  = (0.3, 1,   0.3)
//     COLOR_BLUE   = (0.3, 0.3, 1)
//     COLOR_YELLOW = (1,   1,   0.5)   ← the screen-facing ring
//
// Note these are LIGHTER than three's gizmo colours (three uses saturated
// #ff0000-ish). That desaturation is deliberate in PlayCanvas: the rings sit on
// top of a lit scene and a fully saturated thin line reads as an artefact.

/** Base ring colour per axis, as hex ints for THREE materials. */
export const RING_COLOR = Object.freeze({
  x: 0xff4d4d, // (1, 0.3, 0.3)
  y: 0x4dff4d, // (0.3, 1, 0.3)
  z: 0x4d4dff, // (0.3, 0.3, 1)
  f: 0xb0b0b0, // the screen-facing ring — see SPHERE_COLOR's note on grey
})

/** Hover / active colour: PlayCanvas brightens toward white on hover. */
export const RING_COLOR_HOVER = Object.freeze({
  x: 0xff9999,
  y: 0x99ff99,
  z: 0x9999ff,
  f: 0xffffff,
})

/**
 * The free-rotation ball at the centre, and the screen-facing ring around the
 * outside. Grey, not PlayCanvas' yellow: both handles rotate about the VIEW
 * axis, which has no axis identity to colour-code, and a saturated yellow ring
 * outside three coloured ones reads as a fourth axis.
 */
export const SPHERE_COLOR = 0x8c8c8c
export const SPHERE_OPACITY = 0.28

/**
 * Ring geometry.
 *
 * Radii come from three's rotate PICKERS, not from PlayCanvas' shape config,
 * and that is deliberate: three still owns hit-testing, so a ring drawn at
 * PlayCanvas' radius would be a ring you cannot grab at its edge. The tube
 * thickness and the 180° sector — the two things that actually make it LOOK
 * like PlayCanvas — are PlayCanvas'.
 */
export const RING = Object.freeze({
  // three's X/Y/Z picker: TorusGeometry(0.5, 0.1, 4, 24).
  radius: 0.5,
  // ArcShape's tubeRadius 0.01, nudged up. three draws 0.0075; the thicker tube
  // is what makes these read as solid rather than hairline.
  tube: 0.012,
  // sectorAngle 180: only the camera-facing HALF is drawn at rest, so the far
  // half can't be mistaken for a grabbable near one.
  sector: Math.PI,
  // three's 'E' picker: TorusGeometry(0.75, 0.1, 2, 24). PlayCanvas puts its
  // facing ring at 0.55; matching the picker matters more than matching that.
  facingRadius: 0.75,
  // three's 'XYZE' picker: SphereGeometry(0.25, 10, 8).
  sphereRadius: 0.25,
})

export default RING_COLOR
